var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styles from './TableHeadCell.module.scss';
import cx from 'classnames';
import { Sort } from '../../../../assets/icons';
var TableHeadCell = function (_a) {
    var data = _a.data, onSort = _a.onSort;
    var _b = useState(true), isAsc = _b[0], setIsAcs = _b[1];
    var sortHandler = function () {
        if (typeof data === 'object' && data !== null && 'showSort' in data && data.value !== undefined && onSort) {
            onSort({ field: data.value, isAsc: isAsc, type: data.sortType || 'string' });
            setIsAcs(function (prevState) { return !prevState; });
        }
    };
    var renderHeadCellContent = function (data) {
        var content = null;
        if (data instanceof Object && data.label) {
            content = _jsx("div", __assign({ className: cx(data.cellClassName) }, { children: data.label }));
        }
        else {
            content = _jsx("div", { children: data });
        }
        return content;
    };
    return (_jsx("td", __assign({ className: "".concat(styles.TableCell) }, { children: _jsxs("div", __assign({ className: styles.TableHeadCell }, { children: [renderHeadCellContent(data), typeof data === 'object' && data !== null && 'showSort' in data && data.showSort && (_jsx("div", __assign({ className: styles.TableSort, onClick: sortHandler, "data-testid": 'table-sort' }, { children: _jsx(Sort, {}) })))] })) })));
};
export default TableHeadCell;
//# sourceMappingURL=TableHeadCell.js.map